
































import { defineComponent } from '@vue/composition-api';
import { i18n } from './../../../i18n';

const name = 'ttam-select-list-operator';
export default defineComponent({
  name,
  props: {
    module: {
      type: String,
      default: '',
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    addBtnText: {
      type: String,
      default: () => i18n.t('adgroup_audicence_dmp_create_new'),
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
    disableRefresh: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    dataTeaParams: {
      type: Object,
      default: () => ({ from: '' }),
    },
  },
  setup(props, { emit }) {
    const handleAddClick = () => {
      if (props.disableAdd) {
        return;
      }
      emit('add');
    };
    const handleRefreshClick = () => {
      if (props.disableRefresh) {
        return;
      }
      emit('refresh');
    };

    return { name, handleAddClick, handleRefreshClick };
  },
});
